import React, { useState } from "react";
import "./DataEngineer.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaHome } from "react-icons/fa";

import {
  FaDatabase,
  FaTools,
  FaUserTie,
  FaBriefcase,
  FaChartLine,
  FaCertificate,
} from "react-icons/fa";

const DataEngineer = () => {
  const COURSE_NAME = "Data Engineer";

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    mode: "",
    level: "",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    let value = e.target.value;

    // Name -> only letters and spaces
    if (e.target.name === "name") {
      value = value.replace(/[^A-Za-z\s]/g, "");
    }

    // Email -> lowercase
    if (e.target.name === "email") {
      value = value.toLowerCase();
    }

    // Phone -> only numbers, max 10 digits
    if (e.target.name === "phone") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    setFormData({
      ...formData,
      [e.target.name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    if (
      !formData.name ||
      !formData.phone ||
      !formData.email ||
      !formData.mode ||
      !formData.level
    ) {
      setError("Please fill all fields");
      setLoading(false);
      return;
    }

    if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      setError("Name should contain only letters");
      setLoading(false);
      return;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      setError("Phone number must be exactly 10 digits");
      setLoading(false);
      return;
    }

    if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(formData.email)) {
      setError("Enter a valid email address");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        ...formData,
        courseName: COURSE_NAME,
      };

      const API_URL = `${process.env.REACT_APP_BASE_URL}/api/inquiries`;

      const res = await axios.post(API_URL, payload);

      console.log("RESPONSE:", res.data);

      if (res.data.success) {
        window.open(res.data.whatsappUrl, "_blank");

        setMessage("Redirecting to WhatsApp...");

        setTimeout(() => {
          setMessage("");
        }, 3000);

        setFormData({
          name: "",
          phone: "",
          email: "",
          mode: "",
          level: "",
        });
      }
    } catch (err) {
      console.error("ERROR:", err);

      setError(
        err.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    }

    setLoading(false);
  };

  return (
    <div className="de-hero">
      {message && <div className="success-msg">{message}</div>}
      {error && <div className="error-msg">{error}</div>}

      <div className="breadcrumb">
        <Link to="/">
          <FaHome /> Home
        </Link>{" "}
        / <span>Data Engineer</span>
      </div>

      <div className="overlay">
        <div className="hero-left">
          <span className="badge">AAPS Career</span>

          <h1>
            <span className="white">Data </span>
            <span className="orange">Engineer </span>
            <span className="white">Course</span>
          </h1>

          <ul className="points">
            <li>Build scalable data pipelines using real-world tools</li>
            <li>Work with Big Data technologies like Spark & Hadoop</li>
            <li>Learn cloud platforms (AWS / Azure)</li>
            <li>Hands-on ETL project implementation</li>
            <li>Industry-focused curriculum with practical exposure</li>
          </ul>

          <div className="features">
            <div>
              <FaDatabase /> Data Pipelines
            </div>
            <div>
              <FaTools /> Hands-on Tools
            </div>
            <div>
              <FaUserTie /> Expert Trainers
            </div>
            <div>
              <FaBriefcase /> Placement Support
            </div>
            <div>
              <FaChartLine /> Career Growth
            </div>
            <div>
              <FaCertificate /> Certification
            </div>
          </div>

          <div className="learn">
            <h3>What You Will Learn</h3>
            <div className="tags">
              <span>SQL</span>
              <span>Python</span>
              <span>ETL</span>
              <span>Big Data</span>
              <span>Spark</span>
              <span>Cloud</span>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="form-card">
            <h3>Fill Your Details</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                maxLength="10"
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <select
                name="mode"
                value={formData.mode}
                onChange={handleChange}
                required
              >
                <option value="">Select Training Type</option>
                <option value="Classroom">Classroom</option>
                <option value="Online">Online</option>
              </select>

              <select
                name="level"
                value={formData.level}
                onChange={handleChange}
                required
              >
                <option value="">I am...</option>
                <option value="Beginner">Beginner</option>
                <option value="Student">Student</option>
                <option value="Working Professional">
                  Working Professional
                </option>
              </select>

              <button type="submit" className="book-btn" disabled={loading}>
                {loading ? "Submitting..." : "Book Now"}
              </button>
            </form>

            <div className="divider">OR</div>

            <a href="tel:+919573470659" className="call-btn">
              Call Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataEngineer;
